<template>
  <v-container
    fluid
    class="top-menu pa-0"
  >
    <v-app-bar
      color="#3ACAC9"
      class="app-nav-bar text-white"
      :height="48"
    >
      <v-row
        no-gutters
        class="app-nav-row"
        align="center"
      >
        <v-col
          align-self="center"
          sm="5"
          md="2"
          class="hidden-xs app-nav-title-col"
          style="padding-left: 8px;"
        >
          <router-link
            class="app-nav-title"
            :to="{ path: '/reservations/list'}"
          >
            KP相談カルテ
          </router-link>
        </v-col>
        <v-col
          align-self="stretch"
          class="d-flex align-stretch justify-end"
          cols="12"
          sm="7"
          md="10"
        >
          <!-- 日付カレンダー: 幅が狭くハンバーガー化してもヘッダーに常時表示する -->
          <div
            v-if="hasSearchListener"
            class="app-nav-search d-flex align-center"
          >
            <v-menu
              bottom
              offset-y
              min-width="auto"
              transition="fade-transition"
            >
              <template #activator>
                <VueDatePicker
                  v-model="date"
                  locale="jp"
                  format="yyyy-MM-dd"
                  model-type="yyyy-MM-dd"
                  :teleport="true"
                  :enable-time-picker="false"
                  :clearable="false"
                  auto-apply
                  :min-date="hasOperatorAccess ? null : formattedViewLimitDateFrom"
                  @update:model-value="$emit('search', date)"
                />
              </template>
            </v-menu>
          </div>
          <!-- 折りたたまないメニュー -->
          <v-toolbar-items class="justify-end hidden-md-and-down app-nav-tabs">
            <v-btn
              v-if="canAccessHighRisk"
              :to="{ path: '/face_sheets' }"
              variant="text"
              color="white"
              prepend-icon="mdi-emoticon-outline"
              :class="['app-nav-tab', { 'app-nav-tab--active': isActiveSection('faceSheets') }]"
              :style="navOrderStyle('faceSheets')"
            >
              フェイスシート
            </v-btn>
            <v-btn
              v-if="canAccessNightConsultation"
              :to="{ name: 'list', query: { date: $route.query.date }}"
              variant="text"
              color="white"
              prepend-icon="mdi-weather-night"
              :class="['app-nav-tab', { 'app-nav-tab--active': isActiveSection('night') }]"
              :style="navOrderStyle('night')"
            >
              夜間相談
            </v-btn>
            <v-btn
              v-if="canAccessAnytimeConsultation"
              :to="{ path: '/anytime_consultations', query: { tab_id: '0', department: 1, complete: 0 } }"
              variant="text"
              color="white"
              prepend-icon="mdi-email-outline"
              :class="['app-nav-tab', { 'app-nav-tab--active': isActiveSection('anytime') }]"
              :style="navOrderStyle('anytime')"
            >
              いつでも相談
            </v-btn>
            <v-btn
              v-if="canAccessDaytimeAdvice"
              :to="{ name: 'daytimeAdviceRoom' }"
              variant="text"
              color="white"
              prepend-icon="mdi-comment-outline"
              :class="['app-nav-tab', { 'app-nav-tab--active': isActiveSection('daytime') }]"
              :style="navOrderStyle('daytime')"
            >
              日中助産師
            </v-btn>
            <v-btn
              v-if="hasOperatorAccess"
              :to="{ name: 'shift', query: {date: $route.query.date}}"
              variant="text"
              color="white"
              prepend-icon="mdi-calendar-clock"
              :class="['app-nav-tab', 'app-nav-tab--shift', { 'app-nav-tab--active': isActiveSection('shift') }]"
              :style="navOrderStyle('shift')"
            >
              夜間シフト
            </v-btn>
            <v-btn
              v-if="hasOperatorAccess"
              :to="{ name: 'ac_shift', query: {date: $route.query.date}}"
              variant="text"
              color="white"
              prepend-icon="mdi-calendar-check-outline"
              :class="['app-nav-tab', 'app-nav-tab--shift', { 'app-nav-tab--active': isActiveSection('acShift') }]"
              :style="navOrderStyle('acShift')"
            >
              いつでもシフト
            </v-btn>
            <!-- <v-btn text color="pink">アカウント</v-btn> -->
            <v-btn
              variant="text"
              color="white"
              prepend-icon="mdi-logout"
              class="app-nav-tab"
              :style="navOrderStyle('logout')"
              @click="$emit('logout')"
            >
              ログアウト
            </v-btn>
          </v-toolbar-items>
          <!-- 折りたたみメニュー表示ボタン -->
          <v-app-bar-nav-icon
            class="hidden-lg-and-up"
            @click="drawer = true"
          />
        </v-col>
      </v-row>
    </v-app-bar>
    <!-- 折りたたみメニュー -->
    <v-navigation-drawer
      v-model="drawer"
      position="absolute"
      location="right"
      temporary
    >
      <v-list
        nav
        density="compact"
      >
        <v-list-group
          class="text--accent-4"
          active-class="font-weight-bold"
        >
          <v-list-item
            v-if="canAccessHighRisk"
            link
            :to="{ path: '/face_sheets' }"
          >
            <v-list-item-title>
              フェイスシート
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="canAccessNightConsultation"
            link
            :to="{ name: 'list', query: { date: $route.query.date }}"
          >
            <v-list-item-title class="pink--text">
              夜間相談
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="canAccessAnytimeConsultation"
            link
            :to="{ path: '/anytime_consultations', query: { tab_id: '0', department: 1, complete: 0 } }"
          >
            <v-list-item-title class="pink--text">
              いつでも相談
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="canAccessDaytimeAdvice"
            link
            :to="{ name: 'daytimeAdviceRoom' }"
          >
            <v-list-item-title class="pink--text">
              日中助産師
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="hasOperatorAccess"
            link
            :to="{ name: 'shift', query: {date: $route.query.date}}"
          >
            <v-list-item-title class="pink--text">
              夜間シフト
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="hasOperatorAccess"
            link
            :to="{ name: 'ac_shift', query: {date: $route.query.date}}"
          >
            <v-list-item-title class="pink--text">
              いつでもシフト
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="$emit('logout')"
          >
            <v-list-item-title class="pink--text">
              ログアウト
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import ondutyReservationViewLimitMixin from "../../mixins/onduty_reservation_view_limit.js";

export default {
  name: "TopMenu",
  mixins: [ondutyReservationViewLimitMixin],
  props: {
    onSearch: {
      type: Function,
      default: null
    },
  },
  emits: ["search", "logout"],
  data: () => ({
    date: null,
    drawer: false
  }),
  computed: {
    ...mapGetters(["currentDoctor", "hasAllCapabilities"]),
    formattedViewLimitDateFrom : function (){
      return this.formatDate(this.viewLimitDateFrom);
    },
    today: function() {
      return this.formatDate(new Date());
    },
    hasSearchListener: function() {
      return this.onSearch;
    },
    hasOperatorAccess: function(){
      return this.hasAllCapabilities(["operator:access"]);
    },
    canAccessNightConsultation: function() {
      return this.hasAllCapabilities(["night_consultation:access"]);
    },
    canAccessAnytimeConsultation: function() {
      return this.hasAllCapabilities(["anytime_consultation:access"]);
    },
    canAccessDaytimeAdvice: function() {
      return this.hasAllCapabilities(["daytime_advice:access"]);
    },
    canAccessHighRisk: function() {
      return this.hasAllCapabilities(["high_risk:access"]);
    },
  },
  watch: {
    "$route" () {
      this.date = this.$route.query.date ? this.$route.query.date : this.today;
    },
  },
  created() {
    this.date = this.$route.query.date ? this.$route.query.date : this.today;
  },
  methods: {
    formatDate(date){
      return ("0000" + date.getFullYear()).slice(-4) + "-" + ("00" + (date.getMonth() + 1)).slice(-2) + "-" + ("00" + (date.getDate())).slice(-2);
    },
    isActiveSection(section) {
      const pathPrefixes = {
        faceSheets: "/face_sheets",
        night: "/reservations",
        anytime: "/anytime_consultations",
        daytime: "/daytime_advices",
        shift: "/shifts",
        acShift: "/anytime_consultation_shifts",
      };
      const prefix = pathPrefixes[section];
      return !!prefix && this.$route.path.startsWith(prefix);
    },
    navOrderStyle(section) {
      const orders = {
        dateSearch: 1,
        faceSheets: 2,
        night: 3,
        anytime: 4,
        daytime: 5,
        logout: 6,
        shift: 7,
        acShift: 8,
      };
      return { order: orders[section] };
    }
  }
};
</script>

<style lang="scss">
.top-tab.v-theme--light.v-tabs-bar {
  background-color: rgba(100, 100, 100, 0.2) !important;
}
.dp__input {
  border-radius: var(--dp-border-radius, 6px);
  line-height: 2.15rem;
}
.dp__theme_light {
  --dp-highlight-color: rgba(34, 233, 8, 0.993);
  --dp-primary-color: #ff006f;
  --dp-primary-text-color: #000078;
}
.dp__cell_inner {
  --dp-cell-border-radius: 50%;
}
.v-alert + div > .top-menu > .v-toolbar {
  top: 60px !important;
}
.v-alert + div > .v-tabs {
  margin-top: 60px !important;
}

.top-menu {
  /* v-app-barはposition: fixedなので、この高さで後続コンテンツ用のスペーサーを確保する */
  height: 48px;
}

.app-nav-bar {
  .v-toolbar__content {
    align-items: stretch;
    padding-top: 0;
    padding-bottom: 0;
  }
}

.app-nav-row {
  height: 100%;
  flex-wrap: nowrap; /* 列幅の中途の丸め誤差により本来不要な折り返しが発生し、タイトルが下にずれたりハンバーガーが右端に並ばなくなるのを防ぐ */
}

// Vuetifyの hidden-xs は display: none !important で制御されるため、
// 縦中央揃えは !important を使わない専用クラスで指定する。
// (d-flex 等のユーティリティクラスも !important 付きのため、CSSの定義順によっては
//  hidden-xs の display: none を上書きしてしまい、狭い画面幅でタイトル列が消えず
//  ハンバーガーメニューが画面外に押し出される不具合が発生していた)
.app-nav-title-col {
  display: flex;
  align-items: center;
}

.app-nav-title {
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
  color: inherit;
  text-decoration: none;
}

.app-nav-search {
  height: 100%;
  padding: 0 8px;
}

.app-nav-tabs {
  height: 100%;
  align-items: stretch;
}

.app-nav-tab.v-btn {
  height: 100% !important;
  margin: 0;
  padding: 0 8px;
  border-radius: 0;
  text-transform: none;
  letter-spacing: 0;
  font-weight: 500;
  font-size: 15px;
  opacity: 0.95;
  transition: background-color 0.15s ease;

  .v-btn__content {
    display: flex;
    align-items: center;
  }

  .v-icon {
    opacity: 0.9;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.08);
  }
}

.app-nav-tab--active.v-btn {
  background-color: rgba(0,0,0,0.18);
  opacity: 1;
  font-weight: 700;

  .v-icon {
    opacity: 1;
  }
}

.app-nav-tab--shift.v-btn {
  background-color: #A5A5A5 !important;
}

.app-nav-tab--shift.app-nav-tab--active.v-btn {
  background-color: #8A8A8A !important;
}
</style>
